const PageTransactions = () => {
	return <div>PageTransactions</div>;
};

export default PageTransactions;
